class AdminV2CookiePreferences extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.status = this.querySelector('[role="status"]');
    this.button?.addEventListener('click', this.openPreferences);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.openPreferences);
  }

  openPreferences = async () => {
    this.status.hidden = true;
    this.button.disabled = true;
    let timeout;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Privacy banner unavailable');
      }
      await Promise.race([
        window.privacyBanner.showPreferences(),
        new Promise((_, reject) => {
          timeout = setTimeout(() => reject(new Error('Privacy banner timed out')), 10000);
        }),
      ]);
    } catch {
      this.status.hidden = false;
    } finally {
      clearTimeout(timeout);
      this.button.disabled = false;
    }
  };
}

if (!customElements.get('admin-v2-cookie-preferences')) {
  customElements.define('admin-v2-cookie-preferences', AdminV2CookiePreferences);
}
